import { render } from "./PublishDraftModal.vue?vue&type=template&id=01e55aa8"
import script from "./PublishDraftModal.vue?vue&type=script&lang=js"
export * from "./PublishDraftModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__